/**
 * Update DOM elements with Fetch results
 *
 * @param {Object} content - DOM element
 * @param {string} selector - DOM element to look up in the content
 * @return {undefined}
 */
const updateDom = function(content, selector) {
  const updates = content.querySelector(selector);
  const element = document.querySelector(selector);

  if(!element) return;
  element.innerHTML = '';
  element._initializedModules = []; // Discard initialized modules to allow reloading
  if (updates) {
    element.innerHTML = updates.innerHTML;
  } else if (!updates && selector === '[js-hook-refinement-update=refinement-modal]' && !element.childNodes.length) {
    window.location.reload();
  }
};
export default updateDom;
